export const DEFAULT_COUNTRY = "United States";
